// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ttpSQ","item":"styles_item__xsSRd","label":"styles_label__FcnlW","footer":"styles_footer__Hb-+S","button":"styles_button__uk695"};